import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';
import moment from 'moment';

const reportDataHandlers = {
    [constant.reportData](state, action) {
        return action.payload;
    }
};

const loadingHandlers = {
    [constant.loading](state, action) {
        return action.payload;
    },
}

const urlHandlers = {
    [constant.url](state, action) {
        return action.payload;
    },
}

const searchHandlers = {
    [constant.search](state, action) {
        return { ...state, ...action.payload }
    }
};

export const loading = createReducer(false, loadingHandlers);
export const search = createReducer({ 'sBeginTime': moment().format('YYYY-MM-DD'), 'sEndTime': moment().format('YYYY-MM-DD') }, searchHandlers);
export const reportData = createReducer({}, reportDataHandlers);
export const url = createReducer('', urlHandlers);

export const report = combineReducers({
    loading,
    search,
    url,
    reportData,
})






// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/report/reducers.js